import React from "react";

import {
  ClaimYourInsurance,
  ExclusiveOffers,
  InsuranceStats,
  LandingFaq,
  LandingFooter,
  LandingTestimonials,
  PersuasionBannerInsurance,
  SafenSecureTrav,
  SeoContent,
  WhatsCovered,
  WhyBuyTravIns,
} from "@insurance/landing-ui/components";
import { useBreakpointV2 } from "@tm/ui-widgets";

import { Footer } from "@growth/dweb-footer";
import { PARTNER } from "@tm/isomorphic-utils";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import { GiFooterWrap, PersuasionWrapper } from "./InsuranceLanding.style";
import { InsuranceBottomCompType } from "./types";

const data = [
  {
    title: "Popular Flight Sectors",
    links: [
      {
        text: "Kolkata to Delhi Flight",
        url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/",
      },
      {
        text: "Hyderabad to Delhi Flight",
        url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/",
      },
    ],
  },
];

const InsuranceBottomComp = ({
  bottomCompData,
  footerInfo,
}: InsuranceBottomCompType) => {
  const context = usePartnerContext();
  const device = useBreakpointV2();

  const {
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    claimYourInsurance,
    testimonials,
    faq,
    customNumbers,
    crossSell,
    offers,
    seoContent,
  } = bottomCompData;

  //TODO: check for if(footerInfo) and remove optional chaining to improve performance
  const footerLinks =
    footerInfo
      ?.filter((data) => data.type === "section")
      ?.map((item, index) => ({
        id: index.toString(),
        label: item.title || "",
        listPoints:
          item?.links?.map((link, i) => ({
            id: i.toString(),
            label: link.title || "",
            link: link.url || "",
          })) ?? [],
        icon: "",
      })) ?? [];

  const footerHeading = footerInfo?.find((data) => data.type === "rich-text");
  const footerCopyrightData = footerInfo?.find(
    (data) => data.type === "footnote"
  );

  return (
    <React.Fragment>
      {customNumbers && <InsuranceStats data={customNumbers} />}

      {offers && <ExclusiveOffers data={offers} />}

      {TravelInsData && (
        <WhyBuyTravIns
          title={TravelInsData.title}
          info={TravelInsData.info}
          data={TravelInsData.featureCard}
        />
      )}

      {safeSecureTravel && (
        <SafenSecureTrav
          data={safeSecureTravel.safeTravCrd}
          title={safeSecureTravel.title}
        />
      )}

      {whatsCovered && (
        <WhatsCovered
          data={whatsCovered.travCrd}
          title={whatsCovered.title}
          info={whatsCovered.info}
        />
      )}

      {claimYourInsurance && (
        <ClaimYourInsurance
          title={claimYourInsurance.title}
          info={claimYourInsurance.info}
          data={claimYourInsurance.claimData}
        />
      )}

      {device == "lg" && crossSell && (
        <PersuasionWrapper>
          <PersuasionBannerInsurance
            crossSell={crossSell}
            btnHandler={() => {
              context === PARTNER.GI
                ? window.open(
                    "https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop",
                    "_blank"
                  )
                : window.open("https://www.makemytrip.com/forex", "_blank");
            }}
            // info={persuasionBannerMob.info}
          />
        </PersuasionWrapper>
      )}

      {testimonials && (
        <LandingTestimonials
          customTitle={testimonials?.title}
          test={testimonials?.testimonialData}
        />
      )}

      {seoContent && <SeoContent seoContent={seoContent} />}

      <LandingFaq customTitle={faq?.title} faq={faq?.faqList} />

      {context === PARTNER.GI && device == "lg" ? (
        <GiFooterWrap>
          <Footer data={data} adobe="" />
        </GiFooterWrap>
      ) : (
        <LandingFooter
          playStoreImgURI="https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png"
          appStoreImgURI="https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png"
          facebookImgURI="https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png"
          linkedInImgURI="https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png"
          twitterImgURI="https://tripmoneycmsimgak.mmtcdn.com/img/twitter_Icon_760f145ad2.png"
          footerData={footerLinks}
          footerHeading={footerHeading}
          footerCopyrightData={footerCopyrightData}
        />
      )}
      {/* <LandingFooterInsurance /> */}
    </React.Fragment>
  );
};

export default InsuranceBottomComp;
